import { http, defaultConfig, getUniversityUrl } from './http';

export const getQRCode = (reserveId: number, count: number, dailySale: boolean = false) => {
  const baseURL = getUniversityUrl();
  return http.get<{ payload: QRCodeEntity }>(
    `/rest/forget-card-codes/print?reserveId=${reserveId}&count=${count}&dailySale=${String(dailySale)}`,
    defaultConfig(baseURL)
  );
};
